/**
 * Created by lu on 2018/5/3.
 */
var nb = require('../../nb');
module.exports = nb.define({
    view:{
        'class':'page-sidebar',
        $html:[{
            $name:'ul',
            tag:'ul',
            'class':'uk-nav uk-nav-parent-icon',
            'data-uk-nav':'',
            $html:[{
                tag:'li',
                $html:{
                    tag:'a',
                    href:'console.html',
                    $html:[{
                        tag:'i',
                        'class':'iconfont icon-control'
                    },{
                        tag:'span',
                        $text:nb.bind('console')
                        // $text:'控制台'
                    }]
                }
            },{
                tag:'li',
                $html:{
                    tag:'a',
                    href:'inquiryList.html',
                    $html:[{
                        tag:'i',
                        'class':'iconfont icon-huiyuanVIPrenzhengjiaVzhongyaogaodengji'
                    },{
                        tag:'span',
                        $text:nb.bind('inquiryText')
                        // $text:'询价'
                    }]
                }
            },{
                tag:'li',
                $html:{
                    tag:'a',
                    href:'cart.html',
                    $html:[{
                        tag:'i',
                        'class':'iconfont icon-cart2'
                    },{
                        tag:'span',
                        $text:nb.bind('cart')
                        // $text:'购物车'
                    }]
                }
            },{
                tag:'li',
                $html:{
                    tag:'a',
                    href:'order.html',
                    $html:[{
                        tag:'i',
                        'class':'iconfont icon-order'
                    },{
                        tag:'span',
                        $text:nb.bind('orderManagement')
                        // $text:'订单管理'
                    }]
                }
            },{
                tag:'li',
                'class':'uk-parent',
                $html:[{
                    tag:'a',
                    href:'#',
                    $html:[{
                        tag:'i',
                        'class':'iconfont icon-bill'
                    },{
                        tag:'span',
                        $text:nb.bind('invoiceInformation')
                        // $text:'发票信息'
                    }]
                },{
                    tag:'ul',
                    'class':'uk-nav-sub',
                    $html:[{
                        tag:'li',
                        $html:{
                            tag:'a',
                            href:'invoice.html',
                            $text:nb.bind('issueInvoice')
                            // $text:'开具发票'
                        }
                    },{
                        tag:'li',
                        $html:{
                            tag:'a',
                            href:'invoiceList.html',
                            $text:nb.bind('invoiceHistory')
                            // $text:'发票历史'
                        }
                    },{
                        tag:'li',
                        $html:{
                            tag:'a',
                            href:'invoiceInfo.html',
                            $text:nb.bind('invoiceManagement')
                            // $text:'发票管理'
                        }
                    }]
                }]
            },{
                tag:'li',
                'class':'uk-parent',
                $html:[{
                    tag:'a',
                    href:'#',
                    $html:[{
                        tag:'i',
                        'class':'iconfont icon-user'
                    },{
                        tag:'span',
                        $text:nb.bind('userCenter')
                        // $text:'用户中心'
                    }]
                },{
                    tag:'ul',
                    'class':'uk-nav-sub',
                    $html:[{
                        tag:'li',
                        $html:{
                            tag:'a',
                            href:'companyInfo.html',
                            $text:nb.bind('companyInfo')
                            // $text:'企业信息'
                        }
                    },{
                        tag:'li',
                        $html:{
                            tag:'a',
                            href:'accountInfo.html',
                            $text:nb.bind('accountInfo')
                            // $text:'账户信息'
                        }
                    },{
                        tag:'li',
                        $html:{
                            tag:'a',
                            href:'address.html',
                            $text:nb.bind('address')
                            // $text:'地址管理'
                        }
                    },{
                        tag:'li',
                        $html:{
                            tag:'a',
                            href:'jurisdiction.html',
                            $text:nb.bind('jurisdiction')
                            // $text:'权限管理'
                        // }
                    // },{
                    //     tag:'li',
                    //     $html:{
                    //         tag:'a',
                    //         href:'paymentDaysInfo.html',
                    //         $text:nb.bind('paymentDaysInfo')
                    //         $text:'账期信息'
                        }
                    }]
                }]
            }]
        }]
    },
    method:{
        init:function () {

        },
        onModelReady:function (inModel) {
            this.parent(inModel);
            inModel.onChange('activeLi',function (inEvent,inOpts) {
                var index = inOpts.index;
                var $activeItem = $(this.$('ul').find('>li')[index]);
                $activeItem.addClass('active');
                if($activeItem.hasClass('uk-parent')){
                    var subIndex = inOpts.subIndex || 0;
                    $activeItem.addClass('uk-open');
                    setTimeout(function (args) {
                        $($activeItem.find('.uk-hidden')).removeClass('uk-hidden').css('height','auto');
                    },100);
                    $($activeItem.find('li')[subIndex]).addClass('active');
                }
            },this);
        }
    }
});


//////////////////
// WEBPACK FOOTER
// ../src/js/view/sidebar/Sidebar.js
// module id = 36
// module chunks = 0 1 3 4 7 8 9 10 12 13 14 15 16 18 19 21 25 26 27 28 30